/**
 * testing redux constants
 * 
 * @author    Maurizio Tidei
 * @copyright © 2019 contexagon GmbH
 */


// redux action IDs
export const UPDATE_TEST_STATS              = 'UPDATE_TEST_STATS';
export const ACTIVATE_TEST_MODE             = 'ACTIVATE_TEST_MODE';
